module.exports = __webpack_public_path__ + "img/c-clients-7.jpg";